import { render, staticRenderFns } from "./BorderBox10.vue?vue&type=template&id=34759f56"
import script from "./BorderBox10.vue?vue&type=script&lang=js"
export * from "./BorderBox10.vue?vue&type=script&lang=js"
import style0 from "./BorderBox10.vue?vue&type=style&index=0&id=34759f56&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports